import { supabase } from "services/supabaseClient";

const ORG_ASSETS_BUCKET = "org-assets";

function blobToDataUrl(blob) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = () => reject(reader.error || new Error("Unable to read organization logo."));
    reader.readAsDataURL(blob);
  });
}

function readImageSize(dataUrl) {
  return new Promise((resolve) => {
    const image = new Image();
    image.onload = () => resolve({ width: image.naturalWidth, height: image.naturalHeight });
    image.onerror = () => resolve({ width: 1, height: 1 });
    image.src = dataUrl;
  });
}

export async function loadOrgPdfLogo(orgId) {
  if (!orgId) return null;

  const { data: org, error: orgError } = await supabase
    .from("orgs")
    .select("pdf_logo_path")
    .eq("id", orgId)
    .maybeSingle();

  if (orgError || !org?.pdf_logo_path) return null;

  const { data: blob, error: downloadError } = await supabase.storage
    .from(ORG_ASSETS_BUCKET)
    .download(org.pdf_logo_path);

  if (downloadError || !blob) return null;

  const dataUrl = await blobToDataUrl(blob);
  const size = await readImageSize(dataUrl);
  return {
    dataUrl,
    format: blob.type === "image/jpeg" ? "JPEG" : "PNG",
    ...size,
  };
}

export { ORG_ASSETS_BUCKET };
